<template>
  <button
    class="vs-component vs-switch"
    :class="[
      `vs-switch-${color}`,
      $attrs.class,
      { 'vs-switch-active': isChecked || $attrs.checked },
    ]"
    :style="[$attrs.style, switchStyle]"
    v-bind="buttonAttrs"
  >
    <input
      ref="inputCheckbox"
      class="input-switch vs-switch--input"
      type="checkbox"
      :disabled="$attrs.disabled"
      :checked="isChecked || $attrs.checked"
      :value="currentValue"
      v-bind="inputAttrs"
      @input="toggleValue"
    />
    <span
      ref="on"
      class="text-on text-switch vs-switch--text"
      :class="{ 'active-text': isChecked || $attrs.checked }"
    >
      <slot name="on" />
      <vs-icon
        class="icons-switch vs-switch--icon"
        :icon-pack="iconPack"
        :icon="vsIconOn || vsIcon"
      />
    </span>
    <span
      ref="off"
      class="text-off text-switch vs-switch--text"
      :class="{ 'active-text': !isChecked && !$attrs.checked }"
    >
      <slot name="off" />
      <vs-icon
        class="icons-switch vs-switch--icon"
        :icon-pack="iconPack"
        :icon="vsIconOff || vsIcon"
      />
    </span>
    <span class="vs-circle-switch vs-switch--circle" />
  </button>
</template>

<script>
export default {
  name: "VsSwitch",
  inheritAttrs: false,
  props: {
    modelValue: {
      default: undefined,
    },
    value: {
      default: undefined,
    },
    color: {
      type: String,
      default: "primary",
    },
    vsIcon: {
      type: String,
      default: null,
    },
    vsIconOn: {
      type: String,
      default: null,
    },
    vsIconOff: {
      type: String,
      default: null,
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
    vsValue: {
      default: undefined,
    },
  },
  emits: ["update:modelValue", "input", "change"],
  data() {
    return {
      width: 42,
    };
  },
  computed: {
    currentValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
    isChecked() {
      return Array.isArray(this.currentValue)
        ? this.currentValue.includes(this.vsValue)
        : Boolean(this.currentValue);
    },
    resolvedColor() {
      if (
        this.color.startsWith("#") ||
        this.color.startsWith("rgb") ||
        this.color.startsWith("hsl") ||
        this.color.startsWith("var(")
      ) {
        return this.color;
      }
      return `rgba(var(--vs-${this.color}), 1)`;
    },
    switchStyle() {
      return {
        background: this.currentValue ? this.resolvedColor : null,
        width: `${this.width}px`,
      };
    },
    buttonAttrs() {
      const attrs = { ...this.$attrs };
      ["class", "style", "checked", "onInput"].forEach(
        (key) => delete attrs[key]
      );
      return attrs;
    },
    inputAttrs() {
      const attrs = { ...this.$attrs };
      ["class", "style", "checked", "onInput"].forEach(
        (key) => delete attrs[key]
      );
      return attrs;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.width = Math.max(
        this.$refs.on.clientWidth,
        this.$refs.off.clientWidth
      ) + 24;
    });
  },
  methods: {
    emitValue(value) {
      this.$emit("update:modelValue", value);
      this.$emit("input", value);
    },
    toggleValue(event) {
      if (Array.isArray(this.currentValue)) {
        const value = this.currentValue.slice();
        const index = value.indexOf(this.vsValue);
        if (index === -1) {
          value.push(this.vsValue);
        } else {
          value.splice(index, 1);
        }
        this.emitValue(value);
      } else {
        this.emitValue(!this.currentValue);
      }
      this.$emit("change", event);
    },
  },
};
</script>
